// Central place for all business information / copy.
export const BUSINESS = {
  name: "Veteran's Auto Repair Center",
  shortName: "Veteran's Auto Repair",
  legal: "Veteran's Auto Repair Center LLC",
  address1: "1222 E 11 Mile Rd",
  city: "Madison Heights",
  state: "MI",
  zip: "48071",
  phoneDisplay: "(248) 439-0036",
  phoneDial: "+12484390036",
  email: "veteransautorepair@outlook.com",
  hours: [
    { day: "Monday", range: "8:00 AM – 6:00 PM" },
    { day: "Tuesday", range: "8:00 AM – 6:00 PM" },
    { day: "Wednesday", range: "8:00 AM – 6:00 PM" },
    { day: "Thursday", range: "8:00 AM – 6:00 PM" },
    { day: "Friday", range: "8:00 AM – 6:00 PM" },
    { day: "Saturday", range: "Closed" },
    { day: "Sunday", range: "Closed" },
  ],
  hoursShort: "Mon – Fri · 8:00 AM – 6:00 PM",
  serviceAreas: [
    "Madison Heights",
    "Warren",
    "Royal Oak",
    "Troy",
    "Sterling Heights",
    "Hazel Park",
    "Ferndale",
    "Metro Detroit",
  ],
  mapsEmbed:
    "https://www.google.com/maps?q=1222+E+11+Mile+Rd,+Madison+Heights,+MI+48071&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=1222+E+11+Mile+Rd,+Madison+Heights,+MI+48071",
};

export const SERVICES = [
  { key: "brake-repair", title: "Brake Repair", icon: "Disc", desc: "Pads, rotors, calipers, and full brake system service for safe, confident stops." },
  { key: "oil-changes", title: "Oil Changes", icon: "Droplets", desc: "Conventional, synthetic blend, and full synthetic with honest maintenance advice." },
  { key: "engine-diagnostics", title: "Engine Diagnostics", icon: "Gauge", desc: "Check engine light? Advanced scan tools and experienced techs get real answers." },
  { key: "transmission", title: "Transmission Repair", icon: "Cog", desc: "Fluid services, repairs, and rebuilds for automatic and manual transmissions." },
  { key: "suspension", title: "Suspension & Steering", icon: "CarFront", desc: "Struts, shocks, tie rods, alignments — a smoother, safer ride for Michigan roads." },
  { key: "battery", title: "Battery Replacement", icon: "BatteryCharging", desc: "Free battery testing plus quality replacements that start in cold Michigan winters." },
  { key: "hvac", title: "Heating & Cooling", icon: "ThermometerSun", desc: "A/C recharge, heater cores, blower motors — comfort restored the first visit." },
  { key: "inspection", title: "Full Vehicle Inspection", icon: "ClipboardCheck", desc: "Bumper-to-bumper multi-point inspection with a transparent written report." },
];

export const REVIEWS = [
  { name: "Mary B.", stars: 5, text: "Very friendly and had my car in and out quick. I shopped around and found that Veterans has the best prices." },
  { name: "Brittany B.", stars: 5, text: "This feels like the only auto shop where you won’t get ripped off. Knowledgeable, thorough, and honest." },
  { name: "Elizabeth B.", stars: 5, text: "They were upfront, professional, and even picked me up when my car was ready. Highly recommended!" },
  { name: "Tim H.", stars: 5, text: "Great shop that operates with integrity and honesty. Fixed my car for less than expected." },
  { name: "D. Hight", stars: 5, text: "Fast, honest, and stand behind their work." },
];

export const FAQS = [
  { q: "Do you offer same-day repairs?", a: "Yes — most common repairs such as brakes, batteries, oil changes, and diagnostics are completed the same day. Drop it off in the morning and we’ll keep you updated by phone or text." },
  { q: "Are estimates free?", a: "Absolutely. Every customer receives a clear, written estimate before any work begins. We never perform repairs you haven’t approved." },
  { q: "Do you work on all makes and models?", a: "Yes. Domestic, import, SUVs, trucks, and hybrids — our ASE-certified team services virtually every make and model on the road." },
  { q: "Do veterans receive discounts?", a: "Always. As a veteran-owned shop we proudly offer a year-round military discount to active duty, reservists, and veterans. Just let us know at check-in." },
  { q: "Do you offer financing?", a: "Yes. We partner with leading automotive financing providers so you can get back on the road today and pay over time." },
  { q: "Do you back your repairs with a warranty?", a: "Every repair is backed by a nationwide warranty on parts and labor. If something isn’t right, we make it right — that’s the Veteran’s promise." },
];
